import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const o = ".sc-sent-icon-h{display:flex}", c = o, i = class {
  constructor(e) {
    s(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "8ef0cc601ee3b4eee35b06dd2e703b78097db2f3", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "48e4732c8b29a8f67d5c05d949e526bb3d8265d2", d: "M21.5 12L3.5 3.5L3.5 20.5L21.5 12Z", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "ac59135a61f3304c0ea3d5905eec1cafc47d91cd", d: "M3.5 3.5L12 10.5", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "6200596d2992c44eb57da99e86e0fccfab225ce8", d: "M3.5 20.5L12 13.5", stroke: "auto", "stroke-width": "1.5" }));
  }
};
i.style = c;
export {
  i as sent_icon
};
